module.exports = __webpack_public_path__ + "static/media/Stay Right There.0991d922.jpg";